const Footer = () => {
  return (
    <footer className="px-4 py-8 text-center border-t border-gray-200 mt-8">
      <div className="mb-4">
        <h3 className="text-lg font-bold text-black mb-1">계약 호구방지</h3>
        <p className="text-sm text-gray-600">당신의 권리를 지켜드립니다</p>
      </div>
      
      <div className="flex justify-center gap-4 mb-4 text-sm">
        <a href="#" className="text-gray-600 hover:text-black">
          서비스 소개
        </a>
        <a href="#" className="text-gray-600 hover:text-black">
          이용약관
        </a>
        <a href="#" className="text-gray-600 hover:text-black">
          개인정보처리방침
        </a>
      </div>
      
      <p className="text-xs text-gray-500">
        © 2024 계약 호구방지. All rights reserved.
      </p>
    </footer>
  )
}

export default Footer

